export const STACK_STATE = {
	NONE: 'none',
	BUILDING: 'building',
	SUCCESS: 'success',
	FAILED: 'failed',
	CUSTOMIZE: 'customize',
};

export const RESOURCE_MANAGER = {
	TORQUE: 'torque',
	SLURM: 'slurm',
	NONE: 'none',
};

export const USER_AUTH_TYPE = {
	LOCAL: 'local',
	LDAP: 'ldap',
	OPENID_CONNECT: 'openid_connect',
};

export const USER_ROLE = {
	ADMIN: 'admin',
	USER: 'user',
	INSTRUCTOR: 'instructor',
	PARTICIPANT: 'participant',
	DEMO: 'demo',
};

export const isParticipant = (user) => user?.role?.includes(USER_ROLE.PARTICIPANT);

export const IMAGE_TYPE = {
	HEIDI_STACK: 'heidi-stack',
	CUSTOM_STACK: 'custom-stack'
};

export const ACCELERATOR_TYPES = {
	NONE: '',
	NVIDIA_K80: 'nvidia-tesla-k80',
	NVIDIA_P4: 'nvidia-tesla-p4',
	NVIDIA_P100: 'nvidia-tesla-p100',
	NVIDIA_V100: 'nvidia-tesla-v100',
	NVIDIA_T4: 'nvidia-tesla-t4',
	NVIDIA_A100: 'nvidia-tesla-a100',
	TPU_V2: 'tpu-v2',
	TPU_V3: 'tpu-v3',
};

export const ACCELERATOR_LABELS = {
	[ACCELERATOR_TYPES.NONE]: 'None',
	[ACCELERATOR_TYPES.NVIDIA_K80]: 'NVIDIA Tesla K80',
	[ACCELERATOR_TYPES.NVIDIA_P4]: 'NVIDIA Tesla P4',
	[ACCELERATOR_TYPES.NVIDIA_P100]: 'NVIDIA Tesla P100',
	[ACCELERATOR_TYPES.NVIDIA_V100]: 'NVIDIA Tesla V100',
	[ACCELERATOR_TYPES.NVIDIA_T4]: 'NVIDIA Tesla T4',
	[ACCELERATOR_TYPES.NVIDIA_A100]: 'NVIDIA Tesla A100',
	[ACCELERATOR_TYPES.TPU_V2]: 'Google TPU v2',
	[ACCELERATOR_TYPES.TPU_V3]: 'Google TPU v3',
};

export const OPENID_PROVIDERS = {
	ENTRA: 'entra',
	GOOGLE: 'google',
	AWS: 'aws',
};

// Build mode for stacks - determines how images are built
export const BUILD_MODE = {
	MULTI_IMAGE: 'multi-image', // Legacy: separate server, node, gpu images
	UNIFIED: 'unified',         // New: single heidi image for all node types
};

// Image mode for clusters - determines which image type to use at deploy time
export const IMAGE_MODE = {
	MULTI_IMAGE: 'multi-image', // Legacy: use server/node/gpu specific images
	UNIFIED: 'unified',         // New: use unified heidi image
};
